import { api } from '@mbfab/client-api'
import { isSome } from '@mbfab/shared'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { AdminSidebarContainer } from '@/components/app/admin-sidebar-container'
import { CenteredLoading } from '@/components/app/centered-loading'
import { GraphqlErrorPanel } from '@/components/app/graphql-error-panel'
import { AdminOrderImportContainer } from '@/components/screens/order-line-matching/admin-import-container'
import { ErrorPanel } from '@/components/ui/error-panel'
import { PageHeader } from '@/components/ui/page-header'

export const Route = createFileRoute('/admin/order_line_matching/$tenant_id')({ component: Page })
function Page() {
  const { tenant_id: tenantId } = Route.useParams()
  const query = api.useFetchTenantQuery({ variables: { id: tenantId } })
  const tenant = query.data?.adminTenant
  const navigate = useNavigate()
  return (
    <div className="flex min-h-screen bg-background">
      <AdminSidebarContainer />
      <main className="min-w-0 flex-1 space-y-4 p-6">
        <PageHeader
          parent={{
            // 取得前も戻る導線を出すため、テナント名が分かるまでは汎用名にする
            label: tenant?.name ?? 'テナント詳細',
            onNavigate: () => {
              void navigate({ to: '/admin/tenants/$id', params: { id: tenantId } })
            },
          }}
          title={isSome(tenant) ? `${tenant.name} 発注照合` : '発注照合'}
          description="発注CSVと発注書PDFを取り込み、テナントの発注データを登録します。"
        />
        {query.loading ? (
          <CenteredLoading message="読み込み中..." />
        ) : isSome(query.error) || !isSome(tenant) ? (
          <GraphqlErrorPanel
            error={query.error}
            subject="テナント"
            layout="section"
            onRetry={() => {
              void query.refetch()
            }}
          />
        ) : tenant.setting?.orderLineMatchingEnabled !== true || tenant.status === 'suspended' ? (
          <ErrorPanel
            layout="section"
            title="発注明細照合機能を利用できません"
            description="テナントの状態と機能設定を確認してください。"
          />
        ) : (
          <AdminOrderImportContainer tenantId={tenantId} />
        )}
      </main>
    </div>
  )
}
